import { Button, TextField } from '@cinesend/ui-kit'
import { useState } from 'react'
import axios from 'axios'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

const Login = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState(process.env.VITE_EMAIL || '')
  const [password, setPassword] = useState(process.env.VITE_PASSWORD || '')

  const queryClient = useQueryClient()

  const data = useQuery(['/organization'])
  const organization = data.data

  const logIn = useMutation(
    ({ email, password }) =>
      axios.post(`/token-sign-in`, {
        email,
        password,
      }),
    {
      onSuccess: (res) => {
        // set as default for all reqs.
        localStorage.setItem('user_token', res.data.token)
        axios.defaults.headers.common = {
          Authorization: `Bearer ${res.data.token}`,
        }
        queryClient.invalidateQueries(['/user'])
        navigate('/')
      },
    }
  )
  return (
    <>
      <div className='flex items-center justify-center h-screen w-full bg-neutral-800'>
        <div className='w-full max-w-sm flex flex-col gap-6 bg-white rounded-xl shadow-lg p-8'>
          <div className='flex flex-col items-center gap-4'>
            <img className='max-h-20 max-w-full object-contain' src={organization?.login_logo_url} />
            <h1 className='text-xl font-semibold'>Sign in</h1>
          </div>
          {organization?.oidc_enabled && (
            <>
              <a
                className='font-subheader text-center w-full h-10 rounded-lg px-6 py-2 leading-6 text-sm bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-700'
                href={import.meta.env.VITE_API_URL + '/oidc/login/' + organization?.id}
              >
                Sign in with OIDC
              </a>
              <div className='flex items-center gap-3 text-xs text-neutral-500'>
                <div className='h-px flex-1 bg-neutral-200' />
                or
                <div className='h-px flex-1 bg-neutral-200' />
              </div>
            </>
          )}
          <form
            className='flex flex-col gap-4'
            onSubmit={(e) => {
              e.preventDefault()
              if (!email || !password || logIn.isLoading) return
              logIn.mutate({ email, password })
            }}
          >
            <TextField
              label='Email'
              placeholder='youremail@domain.com'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              label='Password'
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              className='w-full'
              disabled={!email || !password || logIn.isLoading}
              onClick={() => {
                logIn.mutate({ email, password })
              }}
            >
              Login
            </Button>
            {logIn.error?.message && <div className='text-error-600 text-xs'>{logIn.error?.message}</div>}
          </form>
          <Button variant='ghost' onClick={() => navigate('/forgot-password')}>
            Forgot Password?
          </Button>
        </div>
      </div>
    </>
  )
}

export default Login
